export const SET_NAME = 'SET_NAME';

export const setName = args => {
  return {
    type: SET_NAME,
    ...args,
  };
};
